import React from 'react';
import {
  View, StyleSheet, Text, Pressable,
} from 'react-native';
import { useNavigation } from '@react-navigation/native';
import Colors from '../../../../constants/Colors';
import LocationIcon14 from '../../../Map/LocationIcon14';
import { logEvent } from '../../../LogEvent';
import { PressableState } from '../../../PressableStyled';
import { AssetInstance, TemplateType } from '../../../../constants/Types';
import { AppScreen } from '../../../../navigation/LinkingConfiguration';

interface AssetCardLocationFieldProps {
  title: string,
  asset: AssetInstance;
}

const AssetCardLocationField = ({ title, asset }: AssetCardLocationFieldProps) => {
  if (!asset) return null;
  const navigation = useNavigation();

  return <Pressable
    onPress={() => {
      logEvent('AssetCard', 'View_on_map');
      navigation.navigate(AppScreen.MAP as any, {
        floor: asset.locationFloor,
        area: asset.locationArea,
        space: asset.locationSpace,
        assetId: asset.id,
        locationId: asset.locationId,
        assetsView: asset.type === TemplateType.ASSET,
        sensorsView: asset.type === TemplateType.SENSOR || asset.type === TemplateType.METER,
      });
    }}
    style={({ pressed }: PressableState) => [
      styles.buttonContainer,
      { backgroundColor: pressed ? Colors.light.hereworksBlue50 : Colors.light.hereworksWhite100 },
    ]}>
    <View style={{ flexDirection: 'row' }}>
      <LocationIcon14 />
      <Text style={[styles.title, { marginStart: 4 }]}>{title}</Text>
    </View>
  </Pressable>;
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
  },
  buttonContainer: {
    flex: 1,
    paddingVertical: 6,
    backgroundColor: 'red',
  },
  title: {
    fontSize: 12,
    lineHeight: 14,
    fontFamily: 'Roboto_400Regular',
    color: Colors.light.hereworksBlue500,
    marginBottom: 4,
    textDecorationStyle: 'solid',
    textDecorationLine: 'underline',
    textDecorationColor: Colors.light.hereworksBlue500,
  },
});

export default AssetCardLocationField;
